import React, { useMemo, useState, useEffect } from "react";
import objectPath from "object-path";
import { useHtmlClassService } from "../_core/MetronicLayout";
import { HeaderMobile } from "./header-mobile/HeaderMobile";
import { Aside } from "./aside/Aside";
import NewAside from "./aside/NewAside";
import { Footer } from "./footer/Footer";
import { LayoutInit } from "./LayoutInit";
import { SubHeader } from "./subheader/SubHeader";
import { NewSubHeader } from "./subheader/NewSubHeader.js"; // Import the new subheader component
import { QuickPanel } from "./extras/offcanvas/QuickPanel";
import { QuickUser } from "./extras/offcanvas/QuickUser";
import { QuickSearch } from "./extras/offcanvas/QuickSearch";
import { QuickNotification } from "./extras/offcanvas/QuickNotification";
import { QuickActions } from "./extras/offcanvas/QuickActions";
import { ScrollTop } from "./extras/ScrollTop";
import { AnimateLoading } from "../../_partials/controls";

async function loadCss(isAsideToggled) {
  try {
    if (isAsideToggled) {
      await import("./aside/newaside.css");
    } else {
      await import("./aside/aside.css");
    }
  } catch (error) {
    console.error("Error loading CSS:", error);
  }
}

export function Layout({ children }) {
  const uiService = useHtmlClassService();
  const [isAsideToggled, setIsAsideToggled] = useState(false);

  useEffect(() => {
    const savedState = localStorage.getItem("isAsideToggled");
    if (savedState) {
      setIsAsideToggled(JSON.parse(savedState));
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("isAsideToggled", JSON.stringify(isAsideToggled));
  }, [isAsideToggled]);

  const layoutProps = useMemo(() => {
    return {
      selfLayout: objectPath.get(uiService.config, "self.layout"),
      subheaderDisplay: objectPath.get(uiService.config, "subheader.display"),
      contentCssClasses: uiService.getClasses("content", true),
      contentContainerClasses: uiService.getClasses("content_container", true),
      contentExtended: objectPath.get(uiService.config, "content.extended"),
    };
  }, [uiService]);

  const handleToggle = () => {
    setIsAsideToggled((prev) => !prev);
    window.location.reload();
  };

  useEffect(() => {
    loadCss(isAsideToggled);
  }, [isAsideToggled]);

  return layoutProps.selfLayout !== "blank" ? (
    <>
      <HeaderMobile />

      <div className="d-flex flex-column flex-root">
        <div className="d-flex flex-row flex-column-fluid page">
          {isAsideToggled ? <NewAside /> : <Aside />}

          <div className="d-flex flex-column flex-row-fluid wrapper" id="kt_wrapper">
            <div id="kt_content" className={`content ${layoutProps.contentCssClasses} d-flex flex-column flex-column-fluid`}>
              <AnimateLoading />
              {layoutProps.subheaderDisplay && (isAsideToggled ? <NewSubHeader /> : <SubHeader />)}

              {layoutProps.contentExtended && <>{children}</>}

              {!layoutProps.contentExtended && (
                <div className="d-flex flex-column-fluid">
                  <div className={layoutProps.contentContainerClasses}>
                    {children}
                  </div>
                </div>
              )}
            </div>
            {/* <a onClick={handleToggle} style={{ maxWidth: "100px", cursor: "pointer", marginLeft: "25px" }}>
              {isAsideToggled ? "Old Dashboard" : "New Dashboard"}
            </a> */}
            <Footer />
          </div>
        </div>
      </div>
      <QuickUser />
      <QuickPanel />
      <QuickNotification />
      <ScrollTop />
      <QuickSearch />
      <QuickActions />
      <LayoutInit />
    </>
  ) : (
    <div className="d-flex flex-column flex-root">{children}</div>
  );
}
